import { FunctionComponent } from 'react';
import { CompPropsWithChildren, SortableElementProps } from './utils/types';
import ReactDOM from 'react-dom';
import { useSortableElement } from './useSortableElement';

export const SortableComponent = <Props extends Record<string, any>>(
  Component: FunctionComponent<Props>
) => {
  const WrappedComponent = (
    props: CompPropsWithChildren<
      FunctionComponent<Omit<Props, 'reactSortableRef'> & SortableElementProps>
    >
  ) => {
    const {
      ghostContainer,
      onTransitionEnd,
      mergedStyle,
      mergedGhostStyle,
      compProps,
      ref,
      ghostStyle,
      dragTargetClass,
    } = useSortableElement(props);
    return (
      <>
        <Component
          {...(compProps as Props)}
          reactSortableRef={ref}
          style={mergedStyle}
          dragTargetClass={dragTargetClass}
        />
        {ghostContainer &&
          ghostStyle &&
          ReactDOM.createPortal(
            <Component
              {...(compProps as Props)}
              style={mergedGhostStyle}
              onTransitionEnd={onTransitionEnd}
            >
              {(compProps as Props).children}
            </Component>,
            ghostContainer
          )}
      </>
    );
  };
  return WrappedComponent;
};
